import React from 'react';
import { useTheme } from '../contexts/ThemeContext';

const ThemeToggle: React.FC = () => {
  const { mode, setMode } = useTheme();
  const isLight = mode === 'light';

  const getIcon = (iconMode: 'light' | 'dark' | 'auto') => {
    switch (iconMode) {
      case 'light':
        return (
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
            />
          </svg>
        );
      case 'dark':
        return (
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
              d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
            />
          </svg>
        );
      case 'auto':
        return (
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        );
    }
  };

  return (
    <div className={`
      inline-flex rounded-lg border shadow-sm
      ${isLight ? 'border-gray-200 bg-white' : 'border-green-500/30 bg-gray-900'}
    `}>
      {(['auto', 'light', 'dark'] as const).map((themeMode) => (
        <button
          key={themeMode}
          onClick={() => setMode(themeMode)}
          className={`
            p-2 transition-colors duration-200
            ${mode === themeMode 
              ? (isLight 
                  ? 'bg-gray-100 text-gray-900' 
                  : 'bg-green-500/10 text-green-500'
                )
              : (isLight
                  ? 'text-gray-500 hover:text-gray-700 hover:bg-gray-50'
                  : 'text-gray-500 hover:text-green-500 hover:bg-green-500/5'
                )
            }
            ${themeMode === 'auto' ? 'rounded-l-md' : ''}
            ${themeMode === 'dark' ? 'rounded-r-md' : ''}
          `}
          aria-label={`Switch to ${
            themeMode === 'auto' ? 'automatic' :
            themeMode === 'light' ? 'light' : 'dark'
          } theme`}
        >
          {getIcon(themeMode)}
        </button>
      ))}
    </div>
  );
};

export default ThemeToggle; 